import {post} from '@/services/infrastructure/api.service'
import {AuditLogEntry} from '@/types/AuditLog'

export type AuditLogParams = {
    limit?: number
    offset?: number
    from?: string
    to?: string
    subjectType?: string
    action?: string
    correlationId?: string
}

export const fetchAuditLog = async (params: AuditLogParams = {}): Promise<AuditLogEntry[]> => {
    const filters: any = {}

    if (params.from || params.to) {
        const conditions: any[] = []
        if (params.from) conditions.push({filterType: 'timestamp', value: params.from, operator: 'GreaterThanOrEqualTo'})
        if (params.to) conditions.push({filterType: 'timestamp', value: params.to, operator: 'LessThanOrEqualTo'})
        filters.createdAt = conditions.length === 1 ? conditions[0] : {filterType: 'composite', operator: 'And', conditions}
    }
    if (params.subjectType) filters.subjectType = {filterType: 'string', value: params.subjectType, operator: 'Equals'}
    if (params.action) filters.action = {filterType: 'string', value: params.action, operator: 'Equals'}
    if (params.correlationId) filters.correlationId = {filterType: 'string', value: params.correlationId, operator: 'Equals'}

    const result = await post('/audit-log/:getrows', {
        filters,
        sorts: [{column: 'createdAt', direction: 'Desc'}],
        offset: params.offset ?? 0,
        limit: params.limit ?? 500,
    })
    return result ?? []
}

export const fetchEntityAuditTrail = async (entityId: string): Promise<AuditLogEntry[]> => {
    const result = await post('/audit-log/:getrows', {
        filters: {
            subjectId: {filterType: 'string', value: entityId, operator: 'Equals'},
        },
        sorts: [{column: 'createdAt', direction: 'Asc'}],
        offset: 0,
        limit: 500,
    })
    return result ?? []
}

export const actionLabel = (action: string): string => {
    switch (action) {
        case 'created':
            return 'Opprettet'
        case 'updated':
            return 'Oppdatert'
        case 'deleted':
            return 'Slettet'
        default:
            return action
    }
}

export const actionColor = (action: string): string => {
    switch (action) {
        case 'created':
            return 'color: var(--color-success-500)'
        case 'updated':
            return 'color: var(--color-info-500)'
        case 'deleted':
            return 'color: var(--color-error-500)'
        default:
            return ''
    }
}
